// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.en.md?type=frontmatter';
import { demoIndex as dmi0 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.en.md?type=demo-index';
import { frontmatter as fm1, toc as t1 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.zh.md?type=frontmatter';
import { demoIndex as dmi1 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.zh.md?type=demo-index';
import { frontmatter as fm2, toc as t2 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.en.md?type=frontmatter';
import { demoIndex as dmi2 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.en.md?type=demo-index';
import { frontmatter as fm3, toc as t3 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.zh.md?type=frontmatter';
import { demoIndex as dmi3 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.zh.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.en.md?type=frontmatter';
import { demoIndex as dmi4 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.en.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.zh.md?type=frontmatter';
import { demoIndex as dmi5 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.zh.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/angular.en.md?type=frontmatter';
import { demoIndex as dmi6 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/angular.en.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/angular.zh.md?type=frontmatter';
import { demoIndex as dmi7 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/angular.zh.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.en.md?type=frontmatter';
import { demoIndex as dmi8 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.en.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.zh.md?type=frontmatter';
import { demoIndex as dmi9 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.zh.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphInstance.en.md?type=frontmatter';
import { demoIndex as dmi10 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphInstance.en.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphInstance.zh.md?type=frontmatter';
import { demoIndex as dmi11 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphInstance.zh.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/group.en.md?type=frontmatter';
import { demoIndex as dmi12 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/group.en.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/group.zh.md?type=frontmatter';
import { demoIndex as dmi13 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/group.zh.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.en.md?type=frontmatter';
import { demoIndex as dmi14 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.en.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.zh.md?type=frontmatter';
import { demoIndex as dmi15 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.zh.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.en.md?type=frontmatter';
import { demoIndex as dmi16 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.en.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.zh.md?type=frontmatter';
import { demoIndex as dmi17 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.zh.md?type=demo-index';
import { frontmatter as fm18, toc as t18 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.en.md?type=frontmatter';
import { demoIndex as dmi18 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.en.md?type=demo-index';
import { frontmatter as fm19, toc as t19 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.zh.md?type=frontmatter';
import { demoIndex as dmi19 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.zh.md?type=demo-index';
import { frontmatter as fm20, toc as t20 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/interacting.en.md?type=frontmatter';
import { demoIndex as dmi20 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/interacting.en.md?type=demo-index';
import { frontmatter as fm21, toc as t21 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/interacting.zh.md?type=frontmatter';
import { demoIndex as dmi21 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/interacting.zh.md?type=demo-index';
import { frontmatter as fm22, toc as t22 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.en.md?type=frontmatter';
import { demoIndex as dmi22 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.en.md?type=demo-index';
import { frontmatter as fm23, toc as t23 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.zh.md?type=frontmatter';
import { demoIndex as dmi23 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.zh.md?type=demo-index';
import { frontmatter as fm24, toc as t24 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.en.md?type=frontmatter';
import { demoIndex as dmi24 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.en.md?type=demo-index';
import { frontmatter as fm25, toc as t25 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.zh.md?type=frontmatter';
import { demoIndex as dmi25 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.zh.md?type=demo-index';
import { frontmatter as fm26, toc as t26 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.en.md?type=frontmatter';
import { demoIndex as dmi26 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.en.md?type=demo-index';
import { frontmatter as fm27, toc as t27 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.zh.md?type=frontmatter';
import { demoIndex as dmi27 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.zh.md?type=demo-index';
import { frontmatter as fm28, toc as t28 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.en.md?type=frontmatter';
import { demoIndex as dmi28 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.en.md?type=demo-index';
import { frontmatter as fm29, toc as t29 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.zh.md?type=frontmatter';
import { demoIndex as dmi29 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.zh.md?type=demo-index';
import { frontmatter as fm30, toc as t30 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.en.md?type=frontmatter';
import { demoIndex as dmi30 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.en.md?type=demo-index';
import { frontmatter as fm31, toc as t31 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.zh.md?type=frontmatter';
import { demoIndex as dmi31 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.zh.md?type=demo-index';
import { frontmatter as fm32, toc as t32 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.en.md?type=frontmatter';
import { demoIndex as dmi32 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.en.md?type=demo-index';
import { frontmatter as fm33, toc as t33 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.zh.md?type=frontmatter';
import { demoIndex as dmi33 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.zh.md?type=demo-index';
import { frontmatter as fm34, toc as t34 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/vue.en.md?type=frontmatter';
import { demoIndex as dmi34 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/vue.en.md?type=demo-index';
import { frontmatter as fm35, toc as t35 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/vue.zh.md?type=frontmatter';
import { demoIndex as dmi35 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/vue.zh.md?type=demo-index';
import { frontmatter as fm36, toc as t36 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.en.md?type=frontmatter';
import { demoIndex as dmi36 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.en.md?type=demo-index';
import { frontmatter as fm37, toc as t37 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.zh.md?type=frontmatter';
import { demoIndex as dmi37 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.zh.md?type=demo-index';
import { frontmatter as fm38, toc as t38 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.en.md?type=frontmatter';
import { demoIndex as dmi38 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.en.md?type=demo-index';
import { frontmatter as fm39, toc as t39 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.zh.md?type=frontmatter';
import { demoIndex as dmi39 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.zh.md?type=demo-index';
import { frontmatter as fm40, toc as t40 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.en.md?type=frontmatter';
import { demoIndex as dmi40 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.en.md?type=demo-index';
import { frontmatter as fm41, toc as t41 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.zh.md?type=frontmatter';
import { demoIndex as dmi41 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.zh.md?type=demo-index';
import { frontmatter as fm42, toc as t42 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.en.md?type=frontmatter';
import { demoIndex as dmi42 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.en.md?type=demo-index';
import { frontmatter as fm43, toc as t43 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.zh.md?type=frontmatter';
import { demoIndex as dmi43 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.zh.md?type=demo-index';
import { frontmatter as fm44, toc as t44 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.en.md?type=frontmatter';
import { demoIndex as dmi44 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.en.md?type=demo-index';
import { frontmatter as fm45, toc as t45 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.zh.md?type=frontmatter';
import { demoIndex as dmi45 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.zh.md?type=demo-index';
import { frontmatter as fm46, toc as t46 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.en.md?type=frontmatter';
import { demoIndex as dmi46 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.en.md?type=demo-index';
import { frontmatter as fm47, toc as t47 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.zh.md?type=frontmatter';
import { demoIndex as dmi47 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.zh.md?type=demo-index';
import { frontmatter as fm48, toc as t48 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-anchor.en.md?type=frontmatter';
import { demoIndex as dmi48 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-anchor.en.md?type=demo-index';
import { frontmatter as fm49, toc as t49 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-anchor.zh.md?type=frontmatter';
import { demoIndex as dmi49 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-anchor.zh.md?type=demo-index';
import { frontmatter as fm50, toc as t50 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.en.md?type=frontmatter';
import { demoIndex as dmi50 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.en.md?type=demo-index';
import { frontmatter as fm51, toc as t51 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.zh.md?type=frontmatter';
import { demoIndex as dmi51 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.zh.md?type=demo-index';
import { frontmatter as fm52, toc as t52 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.en.md?type=frontmatter';
import { demoIndex as dmi52 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.en.md?type=demo-index';
import { frontmatter as fm53, toc as t53 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.zh.md?type=frontmatter';
import { demoIndex as dmi53 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.zh.md?type=demo-index';
import { frontmatter as fm54, toc as t54 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-layout.en.md?type=frontmatter';
import { demoIndex as dmi54 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-layout.en.md?type=demo-index';
import { frontmatter as fm55, toc as t55 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-layout.zh.md?type=frontmatter';
import { demoIndex as dmi55 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-layout.zh.md?type=demo-index';
import { frontmatter as fm56, toc as t56 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.en.md?type=frontmatter';
import { demoIndex as dmi56 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.en.md?type=demo-index';
import { frontmatter as fm57, toc as t57 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.zh.md?type=frontmatter';
import { demoIndex as dmi57 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.zh.md?type=demo-index';
import { frontmatter as fm58, toc as t58 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.en.md?type=frontmatter';
import { demoIndex as dmi58 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.en.md?type=demo-index';
import { frontmatter as fm59, toc as t59 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.zh.md?type=frontmatter';
import { demoIndex as dmi59 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.zh.md?type=demo-index';
import { frontmatter as fm60, toc as t60 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.en.md?type=frontmatter';
import { demoIndex as dmi60 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.en.md?type=demo-index';
import { frontmatter as fm61, toc as t61 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.zh.md?type=frontmatter';
import { demoIndex as dmi61 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.zh.md?type=demo-index';
import { frontmatter as fm62, toc as t62 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.en.md?type=frontmatter';
import { demoIndex as dmi62 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.en.md?type=demo-index';
import { frontmatter as fm63, toc as t63 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.zh.md?type=frontmatter';
import { demoIndex as dmi63 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.zh.md?type=demo-index';
import { frontmatter as fm64, toc as t64 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.en.md?type=frontmatter';
import { demoIndex as dmi64 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.en.md?type=demo-index';
import { frontmatter as fm65, toc as t65 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.zh.md?type=frontmatter';
import { demoIndex as dmi65 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.zh.md?type=demo-index';
import { frontmatter as fm66, toc as t66 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.en.md?type=frontmatter';
import { demoIndex as dmi66 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.en.md?type=demo-index';
import { frontmatter as fm67, toc as t67 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.zh.md?type=frontmatter';
import { demoIndex as dmi67 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.zh.md?type=demo-index';
import { frontmatter as fm68, toc as t68 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.en.md?type=frontmatter';
import { demoIndex as dmi68 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.en.md?type=demo-index';
import { frontmatter as fm69, toc as t69 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.zh.md?type=frontmatter';
import { demoIndex as dmi69 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.zh.md?type=demo-index';
import { frontmatter as fm70, toc as t70 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/introduction.en.md?type=frontmatter';
import { demoIndex as dmi70 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/introduction.en.md?type=demo-index';
import { frontmatter as fm71, toc as t71 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/introduction.zh.md?type=frontmatter';
import { demoIndex as dmi71 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/introduction.zh.md?type=demo-index';
import { frontmatter as fm72, toc as t72 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useClipboard.en.md?type=frontmatter';
import { demoIndex as dmi72 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useClipboard.en.md?type=demo-index';
import { frontmatter as fm73, toc as t73 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useClipboard.zh.md?type=frontmatter';
import { demoIndex as dmi73 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useClipboard.zh.md?type=demo-index';
import { frontmatter as fm74, toc as t74 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/export.en.md?type=frontmatter';
import { demoIndex as dmi74 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/export.en.md?type=demo-index';
import { frontmatter as fm75, toc as t75 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/export.zh.md?type=frontmatter';
import { demoIndex as dmi75 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/export.zh.md?type=demo-index';
import { frontmatter as fm76, toc as t76 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.en.md?type=frontmatter';
import { demoIndex as dmi76 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.en.md?type=demo-index';
import { frontmatter as fm77, toc as t77 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.zh.md?type=frontmatter';
import { demoIndex as dmi77 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.zh.md?type=demo-index';
import { frontmatter as fm78, toc as t78 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.en.md?type=frontmatter';
import { demoIndex as dmi78 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.en.md?type=demo-index';
import { frontmatter as fm79, toc as t79 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.zh.md?type=frontmatter';
import { demoIndex as dmi79 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.zh.md?type=demo-index';
import { frontmatter as fm80, toc as t80 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.en.md?type=frontmatter';
import { demoIndex as dmi80 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.en.md?type=demo-index';
import { frontmatter as fm81, toc as t81 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.zh.md?type=frontmatter';
import { demoIndex as dmi81 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.zh.md?type=demo-index';
import { frontmatter as fm82, toc as t82 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-tool.en.md?type=frontmatter';
import { demoIndex as dmi82 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-tool.en.md?type=demo-index';
import { frontmatter as fm83, toc as t83 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-tool.zh.md?type=frontmatter';
import { demoIndex as dmi83 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-tool.zh.md?type=demo-index';
import { frontmatter as fm84, toc as t84 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-tool.en.md?type=frontmatter';
import { demoIndex as dmi84 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-tool.en.md?type=demo-index';
import { frontmatter as fm85, toc as t85 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-tool.zh.md?type=frontmatter';
import { demoIndex as dmi85 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-tool.zh.md?type=demo-index';
import { frontmatter as fm86, toc as t86 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/auto-scrollbox.en.md?type=frontmatter';
import { demoIndex as dmi86 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/auto-scrollbox.en.md?type=demo-index';
import { frontmatter as fm87, toc as t87 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/auto-scrollbox.zh.md?type=frontmatter';
import { demoIndex as dmi87 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/auto-scrollbox.zh.md?type=demo-index';
import { frontmatter as fm88, toc as t88 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.en.md?type=frontmatter';
import { demoIndex as dmi88 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.en.md?type=demo-index';
import { frontmatter as fm89, toc as t89 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.zh.md?type=frontmatter';
import { demoIndex as dmi89 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.zh.md?type=demo-index';
import { frontmatter as fm90, toc as t90 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useHistory.en.md?type=frontmatter';
import { demoIndex as dmi90 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useHistory.en.md?type=demo-index';
import { frontmatter as fm91, toc as t91 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useHistory.zh.md?type=frontmatter';
import { demoIndex as dmi91 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useHistory.zh.md?type=demo-index';
import { frontmatter as fm92, toc as t92 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/interaction.en.md?type=frontmatter';
import { demoIndex as dmi92 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/interaction.en.md?type=demo-index';
import { frontmatter as fm93, toc as t93 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/interaction.zh.md?type=frontmatter';
import { demoIndex as dmi93 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/interaction.zh.md?type=demo-index';
import { frontmatter as fm94, toc as t94 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.en.md?type=frontmatter';
import { demoIndex as dmi94 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.en.md?type=demo-index';
import { frontmatter as fm95, toc as t95 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.zh.md?type=frontmatter';
import { demoIndex as dmi95 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.zh.md?type=demo-index';
import { frontmatter as fm96, toc as t96 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.en.md?type=frontmatter';
import { demoIndex as dmi96 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.en.md?type=demo-index';
import { frontmatter as fm97, toc as t97 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.zh.md?type=frontmatter';
import { demoIndex as dmi97 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.zh.md?type=demo-index';
import { frontmatter as fm98, toc as t98 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useExport.en.md?type=frontmatter';
import { demoIndex as dmi98 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useExport.en.md?type=demo-index';
import { frontmatter as fm99, toc as t99 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useExport.zh.md?type=frontmatter';
import { demoIndex as dmi99 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useExport.zh.md?type=demo-index';
import { frontmatter as fm100, toc as t100 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.en.md?type=frontmatter';
import { demoIndex as dmi100 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.en.md?type=demo-index';
import { frontmatter as fm101, toc as t101 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.zh.md?type=frontmatter';
import { demoIndex as dmi101 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.zh.md?type=demo-index';
import { frontmatter as fm102, toc as t102 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.en.md?type=frontmatter';
import { demoIndex as dmi102 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.en.md?type=demo-index';
import { frontmatter as fm103, toc as t103 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.zh.md?type=frontmatter';
import { demoIndex as dmi103 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.zh.md?type=demo-index';
import { frontmatter as fm104, toc as t104 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.en.md?type=frontmatter';
import { demoIndex as dmi104 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.en.md?type=demo-index';
import { frontmatter as fm105, toc as t105 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.zh.md?type=frontmatter';
import { demoIndex as dmi105 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.zh.md?type=demo-index';
import { frontmatter as fm106, toc as t106 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/color-picker.en.md?type=frontmatter';
import { demoIndex as dmi106 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/color-picker.en.md?type=demo-index';
import { frontmatter as fm107, toc as t107 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/color-picker.zh.md?type=frontmatter';
import { demoIndex as dmi107 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/color-picker.zh.md?type=demo-index';
import { frontmatter as fm108, toc as t108 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.en.md?type=frontmatter';
import { demoIndex as dmi108 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.en.md?type=demo-index';
import { frontmatter as fm109, toc as t109 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.zh.md?type=frontmatter';
import { demoIndex as dmi109 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.zh.md?type=demo-index';
import { frontmatter as fm110, toc as t110 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.en.md?type=frontmatter';
import { demoIndex as dmi110 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.en.md?type=demo-index';
import { frontmatter as fm111, toc as t111 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.zh.md?type=frontmatter';
import { demoIndex as dmi111 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.zh.md?type=demo-index';
import { frontmatter as fm112, toc as t112 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/transform.en.md?type=frontmatter';
import { demoIndex as dmi112 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/transform.en.md?type=demo-index';
import { frontmatter as fm113, toc as t113 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/transform.zh.md?type=frontmatter';
import { demoIndex as dmi113 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/transform.zh.md?type=demo-index';
import { frontmatter as fm114, toc as t114 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/filter.en.md?type=frontmatter';
import { demoIndex as dmi114 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/filter.en.md?type=demo-index';
import { frontmatter as fm115, toc as t115 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/filter.zh.md?type=frontmatter';
import { demoIndex as dmi115 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/filter.zh.md?type=demo-index';
import { frontmatter as fm116, toc as t116 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/router.en.md?type=frontmatter';
import { demoIndex as dmi116 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/router.en.md?type=demo-index';
import { frontmatter as fm117, toc as t117 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/router.zh.md?type=frontmatter';
import { demoIndex as dmi117 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/router.zh.md?type=demo-index';
import { frontmatter as fm118, toc as t118 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/contextmenu.en.md?type=frontmatter';
import { demoIndex as dmi118 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/contextmenu.en.md?type=demo-index';
import { frontmatter as fm119, toc as t119 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/contextmenu.zh.md?type=frontmatter';
import { demoIndex as dmi119 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/contextmenu.zh.md?type=demo-index';
import { frontmatter as fm120, toc as t120 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/edge.en.md?type=frontmatter';
import { demoIndex as dmi120 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/edge.en.md?type=demo-index';
import { frontmatter as fm121, toc as t121 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/edge.zh.md?type=frontmatter';
import { demoIndex as dmi121 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/edge.zh.md?type=demo-index';
import { frontmatter as fm122, toc as t122 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.en.md?type=frontmatter';
import { demoIndex as dmi122 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.en.md?type=demo-index';
import { frontmatter as fm123, toc as t123 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.zh.md?type=frontmatter';
import { demoIndex as dmi123 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.zh.md?type=demo-index';
import { frontmatter as fm124, toc as t124 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.en.md?type=frontmatter';
import { demoIndex as dmi124 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.en.md?type=demo-index';
import { frontmatter as fm125, toc as t125 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.zh.md?type=frontmatter';
import { demoIndex as dmi125 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.zh.md?type=demo-index';
import { frontmatter as fm126, toc as t126 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.en.md?type=frontmatter';
import { demoIndex as dmi126 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.en.md?type=demo-index';
import { frontmatter as fm127, toc as t127 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.zh.md?type=frontmatter';
import { demoIndex as dmi127 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.zh.md?type=demo-index';
import { frontmatter as fm128, toc as t128 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.en.md?type=frontmatter';
import { demoIndex as dmi128 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.en.md?type=demo-index';
import { frontmatter as fm129, toc as t129 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.zh.md?type=frontmatter';
import { demoIndex as dmi129 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.zh.md?type=demo-index';
import { frontmatter as fm130, toc as t130 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.en.md?type=frontmatter';
import { demoIndex as dmi130 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.en.md?type=demo-index';
import { frontmatter as fm131, toc as t131 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.zh.md?type=frontmatter';
import { demoIndex as dmi131 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.zh.md?type=demo-index';
import { frontmatter as fm132, toc as t132 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/scrollbox.en.md?type=frontmatter';
import { demoIndex as dmi132 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/scrollbox.en.md?type=demo-index';
import { frontmatter as fm133, toc as t133 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/scrollbox.zh.md?type=frontmatter';
import { demoIndex as dmi133 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/scrollbox.zh.md?type=demo-index';
import { frontmatter as fm134, toc as t134 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.en.md?type=frontmatter';
import { demoIndex as dmi134 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.en.md?type=demo-index';
import { frontmatter as fm135, toc as t135 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.zh.md?type=frontmatter';
import { demoIndex as dmi135 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.zh.md?type=demo-index';
import { frontmatter as fm136, toc as t136 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.en.md?type=frontmatter';
import { demoIndex as dmi136 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.en.md?type=demo-index';
import { frontmatter as fm137, toc as t137 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.zh.md?type=frontmatter';
import { demoIndex as dmi137 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.zh.md?type=demo-index';
import { frontmatter as fm138, toc as t138 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.en.md?type=frontmatter';
import { demoIndex as dmi138 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.en.md?type=demo-index';
import { frontmatter as fm139, toc as t139 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.zh.md?type=frontmatter';
import { demoIndex as dmi139 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.zh.md?type=demo-index';
import { frontmatter as fm140, toc as t140 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.en.md?type=frontmatter';
import { demoIndex as dmi140 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.en.md?type=demo-index';
import { frontmatter as fm141, toc as t141 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.zh.md?type=frontmatter';
import { demoIndex as dmi141 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.zh.md?type=demo-index';
import { frontmatter as fm142, toc as t142 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/devtool.en.md?type=frontmatter';
import { demoIndex as dmi142 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/devtool.en.md?type=demo-index';
import { frontmatter as fm143, toc as t143 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/devtool.zh.md?type=frontmatter';
import { demoIndex as dmi143 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/devtool.zh.md?type=demo-index';
import { frontmatter as fm144, toc as t144 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.en.md?type=frontmatter';
import { demoIndex as dmi144 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.en.md?type=demo-index';
import { frontmatter as fm145, toc as t145 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.zh.md?type=frontmatter';
import { demoIndex as dmi145 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.zh.md?type=demo-index';
import { frontmatter as fm146, toc as t146 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.en.md?type=frontmatter';
import { demoIndex as dmi146 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.en.md?type=demo-index';
import { frontmatter as fm147, toc as t147 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.zh.md?type=frontmatter';
import { demoIndex as dmi147 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.zh.md?type=demo-index';
import { frontmatter as fm148, toc as t148 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/components.en.md?type=frontmatter';
import { demoIndex as dmi148 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/components.en.md?type=demo-index';
import { frontmatter as fm149, toc as t149 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/components.zh.md?type=frontmatter';
import { demoIndex as dmi149 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/components.zh.md?type=demo-index';
import { frontmatter as fm150, toc as t150 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menubar.en.md?type=frontmatter';
import { demoIndex as dmi150 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menubar.en.md?type=demo-index';
import { frontmatter as fm151, toc as t151 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menubar.zh.md?type=frontmatter';
import { demoIndex as dmi151 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menubar.zh.md?type=demo-index';
import { frontmatter as fm152, toc as t152 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/toolbar.en.md?type=frontmatter';
import { demoIndex as dmi152 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/toolbar.en.md?type=demo-index';
import { frontmatter as fm153, toc as t153 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/toolbar.zh.md?type=frontmatter';
import { demoIndex as dmi153 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/toolbar.zh.md?type=demo-index';
import { frontmatter as fm154, toc as t154 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/update.en.md?type=frontmatter';
import { demoIndex as dmi154 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/update.en.md?type=demo-index';
import { frontmatter as fm155, toc as t155 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/update.zh.md?type=frontmatter';
import { demoIndex as dmi155 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/update.zh.md?type=demo-index';
import { frontmatter as fm156, toc as t156 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.en.md?type=frontmatter';
import { demoIndex as dmi156 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.en.md?type=demo-index';
import { frontmatter as fm157, toc as t157 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.zh.md?type=frontmatter';
import { demoIndex as dmi157 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.zh.md?type=demo-index';
import { frontmatter as fm158, toc as t158 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/cell.en.md?type=frontmatter';
import { demoIndex as dmi158 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/cell.en.md?type=demo-index';
import { frontmatter as fm159, toc as t159 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/cell.zh.md?type=frontmatter';
import { demoIndex as dmi159 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/cell.zh.md?type=demo-index';
import { frontmatter as fm160, toc as t160 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/edge.en.md?type=frontmatter';
import { demoIndex as dmi160 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/edge.en.md?type=demo-index';
import { frontmatter as fm161, toc as t161 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/edge.zh.md?type=frontmatter';
import { demoIndex as dmi161 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/edge.zh.md?type=demo-index';
import { frontmatter as fm162, toc as t162 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/node.en.md?type=frontmatter';
import { demoIndex as dmi162 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/node.en.md?type=demo-index';
import { frontmatter as fm163, toc as t163 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/node.zh.md?type=frontmatter';
import { demoIndex as dmi163 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/node.zh.md?type=demo-index';
import { frontmatter as fm164, toc as t164 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/animation.en.md?type=frontmatter';
import { demoIndex as dmi164 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/animation.en.md?type=demo-index';
import { frontmatter as fm165, toc as t165 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/animation.zh.md?type=frontmatter';
import { demoIndex as dmi165 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/animation.zh.md?type=demo-index';
import { frontmatter as fm166, toc as t166 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.en.md?type=frontmatter';
import { demoIndex as dmi166 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.en.md?type=demo-index';
import { frontmatter as fm167, toc as t167 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.zh.md?type=frontmatter';
import { demoIndex as dmi167 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.zh.md?type=demo-index';
import { frontmatter as fm168, toc as t168 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/model.en.md?type=frontmatter';
import { demoIndex as dmi168 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/model.en.md?type=demo-index';
import { frontmatter as fm169, toc as t169 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/model.zh.md?type=frontmatter';
import { demoIndex as dmi169 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/model.zh.md?type=demo-index';
import { frontmatter as fm170, toc as t170 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/view.en.md?type=frontmatter';
import { demoIndex as dmi170 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/view.en.md?type=demo-index';
import { frontmatter as fm171, toc as t171 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/view.zh.md?type=frontmatter';
import { demoIndex as dmi171 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/view.zh.md?type=demo-index';
import { frontmatter as fm172, toc as t172 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menu.en.md?type=frontmatter';
import { demoIndex as dmi172 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menu.en.md?type=demo-index';
import { frontmatter as fm173, toc as t173 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menu.zh.md?type=frontmatter';
import { demoIndex as dmi173 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menu.zh.md?type=demo-index';
import { frontmatter as fm174, toc as t174 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/layout.en.md?type=frontmatter';
import { demoIndex as dmi174 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/layout.en.md?type=demo-index';
import { frontmatter as fm175, toc as t175 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/layout.zh.md?type=frontmatter';
import { demoIndex as dmi175 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/layout.zh.md?type=demo-index';
import { frontmatter as fm176, toc as t176 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.en.md?type=frontmatter';
import { demoIndex as dmi176 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.en.md?type=demo-index';
import { frontmatter as fm177, toc as t177 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.zh.md?type=frontmatter';
import { demoIndex as dmi177 } from '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.zh.md?type=demo-index';
import { frontmatter as fm178, toc as t178 } from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/@antv+dumi-theme-antv@0.7.9_3d088f8c859ded74fc5477a74dbf8e87/node_modules/@antv/dumi-theme-antv/dist/pages/Index?type=frontmatter';
import { frontmatter as fm179, toc as t179 } from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/@antv+dumi-theme-antv@0.7.9_3d088f8c859ded74fc5477a74dbf8e87/node_modules/@antv/dumi-theme-antv/dist/pages/Index?type=frontmatter';
import { frontmatter as fm180, toc as t180 } from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/@antv+dumi-theme-antv@0.7.9_3d088f8c859ded74fc5477a74dbf8e87/node_modules/@antv/dumi-theme-antv/dist/pages/Index?type=frontmatter';
import { frontmatter as fm181, toc as t181 } from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/@antv+dumi-theme-antv@0.7.9_3d088f8c859ded74fc5477a74dbf8e87/node_modules/@antv/dumi-theme-antv/dist/pages/Examples?type=frontmatter';
import { frontmatter as fm182, toc as t182 } from '/Users/gaofuhong/X6-v2/node_modules/.pnpm/@antv+dumi-theme-antv@0.7.9_3d088f8c859ded74fc5477a74dbf8e87/node_modules/@antv/dumi-theme-antv/dist/pages/Examples?type=frontmatter';

export const filesMeta = {
  'docs/tutorial/intermediate/connection-point.en': {
    frontmatter: fm0,
    toc: t0,
    demoIndex: dmi0,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.en.md?type=text'),
  },
  'docs/tutorial/intermediate/connection-point.zh': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/connection-point.zh.md?type=text'),
  },
  'docs/api/registry/port-label-layout.en': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.en.md?type=text'),
  },
  'docs/api/registry/port-label-layout.zh': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-label-layout.zh.md?type=text'),
  },
  'docs/api/registry/connection-point.en': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.en.md?type=text'),
  },
  'docs/api/registry/connection-point.zh': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connection-point.zh.md?type=text'),
  },
  'docs/tutorial/intermediate/angular.en': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/angular.en.md?type=text'),
  },
  'docs/tutorial/intermediate/angular.zh': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/angular.zh.md?type=text'),
  },
  'docs/tutorial/basic/serialization.en': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.en.md?type=text'),
  },
  'docs/tutorial/basic/serialization.zh': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.zh.md?type=text'),
  },
  'docs/xflow/hooks/useGraphInstance.en': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphInstance.en.md?type=text'),
  },
  'docs/xflow/hooks/useGraphInstance.zh': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphInstance.zh.md?type=text'),
  },
  'docs/tutorial/intermediate/group.en': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/group.en.md?type=text'),
  },
  'docs/tutorial/intermediate/group.zh': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/group.zh.md?type=text'),
  },
  'docs/tutorial/intermediate/react.en': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.en.md?type=text'),
  },
  'docs/tutorial/intermediate/react.zh': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.zh.md?type=text'),
  },
  'docs/tutorial/intermediate/tools.en': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.en.md?type=text'),
  },
  'docs/tutorial/intermediate/tools.zh': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.zh.md?type=text'),
  },
  'docs/xflow/components/background.en': {
    frontmatter: fm18,
    toc: t18,
    demoIndex: dmi18,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.en.md?type=text'),
  },
  'docs/xflow/components/background.zh': {
    frontmatter: fm19,
    toc: t19,
    demoIndex: dmi19,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/background.zh.md?type=text'),
  },
  'docs/tutorial/basic/interacting.en': {
    frontmatter: fm20,
    toc: t20,
    demoIndex: dmi20,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/interacting.en.md?type=text'),
  },
  'docs/tutorial/basic/interacting.zh': {
    frontmatter: fm21,
    toc: t21,
    demoIndex: dmi21,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/interacting.zh.md?type=text'),
  },
  'docs/tutorial/intermediate/html.en': {
    frontmatter: fm22,
    toc: t22,
    demoIndex: dmi22,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.en.md?type=text'),
  },
  'docs/tutorial/intermediate/html.zh': {
    frontmatter: fm23,
    toc: t23,
    demoIndex: dmi23,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/html.zh.md?type=text'),
  },
  'docs/tutorial/plugins/clipboard.en': {
    frontmatter: fm24,
    toc: t24,
    demoIndex: dmi24,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.en.md?type=text'),
  },
  'docs/tutorial/plugins/clipboard.zh': {
    frontmatter: fm25,
    toc: t25,
    demoIndex: dmi25,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/clipboard.zh.md?type=text'),
  },
  'docs/tutorial/plugins/selection.en': {
    frontmatter: fm26,
    toc: t26,
    demoIndex: dmi26,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.en.md?type=text'),
  },
  'docs/tutorial/plugins/selection.zh': {
    frontmatter: fm27,
    toc: t27,
    demoIndex: dmi27,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.zh.md?type=text'),
  },
  'docs/tutorial/plugins/transform.en': {
    frontmatter: fm28,
    toc: t28,
    demoIndex: dmi28,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.en.md?type=text'),
  },
  'docs/tutorial/plugins/transform.zh': {
    frontmatter: fm29,
    toc: t29,
    demoIndex: dmi29,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.zh.md?type=text'),
  },
  'docs/xflow/components/clipboard.en': {
    frontmatter: fm30,
    toc: t30,
    demoIndex: dmi30,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.en.md?type=text'),
  },
  'docs/xflow/components/clipboard.zh': {
    frontmatter: fm31,
    toc: t31,
    demoIndex: dmi31,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/clipboard.zh.md?type=text'),
  },
  'docs/xflow/components/transform.en': {
    frontmatter: fm32,
    toc: t32,
    demoIndex: dmi32,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.en.md?type=text'),
  },
  'docs/xflow/components/transform.zh': {
    frontmatter: fm33,
    toc: t33,
    demoIndex: dmi33,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/transform.zh.md?type=text'),
  },
  'docs/tutorial/intermediate/vue.en': {
    frontmatter: fm34,
    toc: t34,
    demoIndex: dmi34,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/vue.en.md?type=text'),
  },
  'docs/tutorial/intermediate/vue.zh': {
    frontmatter: fm35,
    toc: t35,
    demoIndex: dmi35,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/vue.zh.md?type=text'),
  },
  'docs/tutorial/plugins/keyboard.en': {
    frontmatter: fm36,
    toc: t36,
    demoIndex: dmi36,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.en.md?type=text'),
  },
  'docs/tutorial/plugins/keyboard.zh': {
    frontmatter: fm37,
    toc: t37,
    demoIndex: dmi37,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/keyboard.zh.md?type=text'),
  },
  'docs/tutorial/plugins/scroller.en': {
    frontmatter: fm38,
    toc: t38,
    demoIndex: dmi38,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.en.md?type=text'),
  },
  'docs/tutorial/plugins/scroller.zh': {
    frontmatter: fm39,
    toc: t39,
    demoIndex: dmi39,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/scroller.zh.md?type=text'),
  },
  'docs/tutorial/plugins/snapline.en': {
    frontmatter: fm40,
    toc: t40,
    demoIndex: dmi40,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.en.md?type=text'),
  },
  'docs/tutorial/plugins/snapline.zh': {
    frontmatter: fm41,
    toc: t41,
    demoIndex: dmi41,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/snapline.zh.md?type=text'),
  },
  'docs/xflow/components/snapline.en': {
    frontmatter: fm42,
    toc: t42,
    demoIndex: dmi42,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.en.md?type=text'),
  },
  'docs/xflow/components/snapline.zh': {
    frontmatter: fm43,
    toc: t43,
    demoIndex: dmi43,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.zh.md?type=text'),
  },
  'docs/xflow/hooks/useGraphEvent.en': {
    frontmatter: fm44,
    toc: t44,
    demoIndex: dmi44,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.en.md?type=text'),
  },
  'docs/xflow/hooks/useGraphEvent.zh': {
    frontmatter: fm45,
    toc: t45,
    demoIndex: dmi45,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphEvent.zh.md?type=text'),
  },
  'docs/xflow/hooks/useGraphStore.en': {
    frontmatter: fm46,
    toc: t46,
    demoIndex: dmi46,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.en.md?type=text'),
  },
  'docs/xflow/hooks/useGraphStore.zh': {
    frontmatter: fm47,
    toc: t47,
    demoIndex: dmi47,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useGraphStore.zh.md?type=text'),
  },
  'docs/api/registry/edge-anchor.en': {
    frontmatter: fm48,
    toc: t48,
    demoIndex: dmi48,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-anchor.en.md?type=text'),
  },
  'docs/api/registry/edge-anchor.zh': {
    frontmatter: fm49,
    toc: t49,
    demoIndex: dmi49,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-anchor.zh.md?type=text'),
  },
  'docs/api/registry/highlighter.en': {
    frontmatter: fm50,
    toc: t50,
    demoIndex: dmi50,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.en.md?type=text'),
  },
  'docs/api/registry/highlighter.zh': {
    frontmatter: fm51,
    toc: t51,
    demoIndex: dmi51,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.zh.md?type=text'),
  },
  'docs/api/registry/node-anchor.en': {
    frontmatter: fm52,
    toc: t52,
    demoIndex: dmi52,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.en.md?type=text'),
  },
  'docs/api/registry/node-anchor.zh': {
    frontmatter: fm53,
    toc: t53,
    demoIndex: dmi53,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.zh.md?type=text'),
  },
  'docs/api/registry/port-layout.en': {
    frontmatter: fm54,
    toc: t54,
    demoIndex: dmi54,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-layout.en.md?type=text'),
  },
  'docs/api/registry/port-layout.zh': {
    frontmatter: fm55,
    toc: t55,
    demoIndex: dmi55,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/port-layout.zh.md?type=text'),
  },
  'docs/tutorial/getting-started.en': {
    frontmatter: fm56,
    toc: t56,
    demoIndex: dmi56,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.en.md?type=text'),
  },
  'docs/tutorial/getting-started.zh': {
    frontmatter: fm57,
    toc: t57,
    demoIndex: dmi57,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/getting-started.zh.md?type=text'),
  },
  'docs/tutorial/plugins/history.en': {
    frontmatter: fm58,
    toc: t58,
    demoIndex: dmi58,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.en.md?type=text'),
  },
  'docs/tutorial/plugins/history.zh': {
    frontmatter: fm59,
    toc: t59,
    demoIndex: dmi59,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/history.zh.md?type=text'),
  },
  'docs/tutorial/plugins/minimap.en': {
    frontmatter: fm60,
    toc: t60,
    demoIndex: dmi60,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.en.md?type=text'),
  },
  'docs/tutorial/plugins/minimap.zh': {
    frontmatter: fm61,
    toc: t61,
    demoIndex: dmi61,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.zh.md?type=text'),
  },
  'docs/tutorial/plugins/stencil.en': {
    frontmatter: fm62,
    toc: t62,
    demoIndex: dmi62,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.en.md?type=text'),
  },
  'docs/tutorial/plugins/stencil.zh': {
    frontmatter: fm63,
    toc: t63,
    demoIndex: dmi63,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/stencil.zh.md?type=text'),
  },
  'docs/xflow/components/control.en': {
    frontmatter: fm64,
    toc: t64,
    demoIndex: dmi64,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.en.md?type=text'),
  },
  'docs/xflow/components/control.zh': {
    frontmatter: fm65,
    toc: t65,
    demoIndex: dmi65,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/control.zh.md?type=text'),
  },
  'docs/xflow/components/history.en': {
    frontmatter: fm66,
    toc: t66,
    demoIndex: dmi66,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.en.md?type=text'),
  },
  'docs/xflow/components/history.zh': {
    frontmatter: fm67,
    toc: t67,
    demoIndex: dmi67,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.zh.md?type=text'),
  },
  'docs/xflow/components/minimap.en': {
    frontmatter: fm68,
    toc: t68,
    demoIndex: dmi68,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.en.md?type=text'),
  },
  'docs/xflow/components/minimap.zh': {
    frontmatter: fm69,
    toc: t69,
    demoIndex: dmi69,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/minimap.zh.md?type=text'),
  },
  'docs/xflow/guide/introduction.en': {
    frontmatter: fm70,
    toc: t70,
    demoIndex: dmi70,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/introduction.en.md?type=text'),
  },
  'docs/xflow/guide/introduction.zh': {
    frontmatter: fm71,
    toc: t71,
    demoIndex: dmi71,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/introduction.zh.md?type=text'),
  },
  'docs/xflow/hooks/useClipboard.en': {
    frontmatter: fm72,
    toc: t72,
    demoIndex: dmi72,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useClipboard.en.md?type=text'),
  },
  'docs/xflow/hooks/useClipboard.zh': {
    frontmatter: fm73,
    toc: t73,
    demoIndex: dmi73,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useClipboard.zh.md?type=text'),
  },
  'docs/tutorial/plugins/export.en': {
    frontmatter: fm74,
    toc: t74,
    demoIndex: dmi74,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/export.en.md?type=text'),
  },
  'docs/tutorial/plugins/export.zh': {
    frontmatter: fm75,
    toc: t75,
    demoIndex: dmi75,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/export.zh.md?type=text'),
  },
  'docs/xflow/guide/quick-start.en': {
    frontmatter: fm76,
    toc: t76,
    demoIndex: dmi76,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.en.md?type=text'),
  },
  'docs/xflow/guide/quick-start.zh': {
    frontmatter: fm77,
    toc: t77,
    demoIndex: dmi77,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/guide/quick-start.zh.md?type=text'),
  },
  'docs/xflow/hooks/useKeyboard.en': {
    frontmatter: fm78,
    toc: t78,
    demoIndex: dmi78,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.en.md?type=text'),
  },
  'docs/xflow/hooks/useKeyboard.zh': {
    frontmatter: fm79,
    toc: t79,
    demoIndex: dmi79,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useKeyboard.zh.md?type=text'),
  },
  'docs/api/registry/connector.en': {
    frontmatter: fm80,
    toc: t80,
    demoIndex: dmi80,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.en.md?type=text'),
  },
  'docs/api/registry/connector.zh': {
    frontmatter: fm81,
    toc: t81,
    demoIndex: dmi81,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/connector.zh.md?type=text'),
  },
  'docs/api/registry/edge-tool.en': {
    frontmatter: fm82,
    toc: t82,
    demoIndex: dmi82,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-tool.en.md?type=text'),
  },
  'docs/api/registry/edge-tool.zh': {
    frontmatter: fm83,
    toc: t83,
    demoIndex: dmi83,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/edge-tool.zh.md?type=text'),
  },
  'docs/api/registry/node-tool.en': {
    frontmatter: fm84,
    toc: t84,
    demoIndex: dmi84,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-tool.en.md?type=text'),
  },
  'docs/api/registry/node-tool.zh': {
    frontmatter: fm85,
    toc: t85,
    demoIndex: dmi85,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-tool.zh.md?type=text'),
  },
  'docs/temp/ui/auto-scrollbox.en': {
    frontmatter: fm86,
    toc: t86,
    demoIndex: dmi86,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/auto-scrollbox.en.md?type=text'),
  },
  'docs/temp/ui/auto-scrollbox.zh': {
    frontmatter: fm87,
    toc: t87,
    demoIndex: dmi87,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/auto-scrollbox.zh.md?type=text'),
  },
  'docs/xflow/components/graph.en': {
    frontmatter: fm88,
    toc: t88,
    demoIndex: dmi88,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.en.md?type=text'),
  },
  'docs/xflow/components/graph.zh': {
    frontmatter: fm89,
    toc: t89,
    demoIndex: dmi89,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.zh.md?type=text'),
  },
  'docs/xflow/hooks/useHistory.en': {
    frontmatter: fm90,
    toc: t90,
    demoIndex: dmi90,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useHistory.en.md?type=text'),
  },
  'docs/xflow/hooks/useHistory.zh': {
    frontmatter: fm91,
    toc: t91,
    demoIndex: dmi91,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useHistory.zh.md?type=text'),
  },
  'docs/api/model/interaction.en': {
    frontmatter: fm92,
    toc: t92,
    demoIndex: dmi92,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/interaction.en.md?type=text'),
  },
  'docs/api/model/interaction.zh': {
    frontmatter: fm93,
    toc: t93,
    demoIndex: dmi93,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/interaction.zh.md?type=text'),
  },
  'docs/tutorial/basic/events.en': {
    frontmatter: fm94,
    toc: t94,
    demoIndex: dmi94,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.en.md?type=text'),
  },
  'docs/tutorial/basic/events.zh': {
    frontmatter: fm95,
    toc: t95,
    demoIndex: dmi95,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.zh.md?type=text'),
  },
  'docs/xflow/components/grid.en': {
    frontmatter: fm96,
    toc: t96,
    demoIndex: dmi96,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.en.md?type=text'),
  },
  'docs/xflow/components/grid.zh': {
    frontmatter: fm97,
    toc: t97,
    demoIndex: dmi97,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/grid.zh.md?type=text'),
  },
  'docs/xflow/hooks/useExport.en': {
    frontmatter: fm98,
    toc: t98,
    demoIndex: dmi98,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useExport.en.md?type=text'),
  },
  'docs/xflow/hooks/useExport.zh': {
    frontmatter: fm99,
    toc: t99,
    demoIndex: dmi99,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useExport.zh.md?type=text'),
  },
  'docs/api/graph/background.en': {
    frontmatter: fm100,
    toc: t100,
    demoIndex: dmi100,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.en.md?type=text'),
  },
  'docs/api/graph/background.zh': {
    frontmatter: fm101,
    toc: t101,
    demoIndex: dmi101,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.zh.md?type=text'),
  },
  'docs/api/graph/coordinate.en': {
    frontmatter: fm102,
    toc: t102,
    demoIndex: dmi102,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.en.md?type=text'),
  },
  'docs/api/graph/coordinate.zh': {
    frontmatter: fm103,
    toc: t103,
    demoIndex: dmi103,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/coordinate.zh.md?type=text'),
  },
  'docs/api/graph/mousewheel.en': {
    frontmatter: fm104,
    toc: t104,
    demoIndex: dmi104,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.en.md?type=text'),
  },
  'docs/api/graph/mousewheel.zh': {
    frontmatter: fm105,
    toc: t105,
    demoIndex: dmi105,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/mousewheel.zh.md?type=text'),
  },
  'docs/temp/ui/color-picker.en': {
    frontmatter: fm106,
    toc: t106,
    demoIndex: dmi106,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/color-picker.en.md?type=text'),
  },
  'docs/temp/ui/color-picker.zh': {
    frontmatter: fm107,
    toc: t107,
    demoIndex: dmi107,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/color-picker.zh.md?type=text'),
  },
  'docs/tutorial/basic/graph.en': {
    frontmatter: fm108,
    toc: t108,
    demoIndex: dmi108,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.en.md?type=text'),
  },
  'docs/tutorial/basic/graph.zh': {
    frontmatter: fm109,
    toc: t109,
    demoIndex: dmi109,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/graph.zh.md?type=text'),
  },
  'docs/tutorial/plugins/dnd.en': {
    frontmatter: fm110,
    toc: t110,
    demoIndex: dmi110,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.en.md?type=text'),
  },
  'docs/tutorial/plugins/dnd.zh': {
    frontmatter: fm111,
    toc: t111,
    demoIndex: dmi111,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/dnd.zh.md?type=text'),
  },
  'docs/api/graph/transform.en': {
    frontmatter: fm112,
    toc: t112,
    demoIndex: dmi112,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/transform.en.md?type=text'),
  },
  'docs/api/graph/transform.zh': {
    frontmatter: fm113,
    toc: t113,
    demoIndex: dmi113,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/transform.zh.md?type=text'),
  },
  'docs/api/registry/filter.en': {
    frontmatter: fm114,
    toc: t114,
    demoIndex: dmi114,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/filter.en.md?type=text'),
  },
  'docs/api/registry/filter.zh': {
    frontmatter: fm115,
    toc: t115,
    demoIndex: dmi115,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/filter.zh.md?type=text'),
  },
  'docs/api/registry/router.en': {
    frontmatter: fm116,
    toc: t116,
    demoIndex: dmi116,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/router.en.md?type=text'),
  },
  'docs/api/registry/router.zh': {
    frontmatter: fm117,
    toc: t117,
    demoIndex: dmi117,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/router.zh.md?type=text'),
  },
  'docs/temp/ui/contextmenu.en': {
    frontmatter: fm118,
    toc: t118,
    demoIndex: dmi118,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/contextmenu.en.md?type=text'),
  },
  'docs/temp/ui/contextmenu.zh': {
    frontmatter: fm119,
    toc: t119,
    demoIndex: dmi119,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/contextmenu.zh.md?type=text'),
  },
  'docs/tutorial/basic/edge.en': {
    frontmatter: fm120,
    toc: t120,
    demoIndex: dmi120,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/edge.en.md?type=text'),
  },
  'docs/tutorial/basic/edge.zh': {
    frontmatter: fm121,
    toc: t121,
    demoIndex: dmi121,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/edge.zh.md?type=text'),
  },
  'docs/tutorial/basic/node.en': {
    frontmatter: fm122,
    toc: t122,
    demoIndex: dmi122,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.en.md?type=text'),
  },
  'docs/tutorial/basic/node.zh': {
    frontmatter: fm123,
    toc: t123,
    demoIndex: dmi123,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/node.zh.md?type=text'),
  },
  'docs/tutorial/basic/port.en': {
    frontmatter: fm124,
    toc: t124,
    demoIndex: dmi124,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.en.md?type=text'),
  },
  'docs/tutorial/basic/port.zh': {
    frontmatter: fm125,
    toc: t125,
    demoIndex: dmi125,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/port.zh.md?type=text'),
  },
  'docs/xflow/hooks/useDnd.en': {
    frontmatter: fm126,
    toc: t126,
    demoIndex: dmi126,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.en.md?type=text'),
  },
  'docs/xflow/hooks/useDnd.zh': {
    frontmatter: fm127,
    toc: t127,
    demoIndex: dmi127,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/hooks/useDnd.zh.md?type=text'),
  },
  'docs/api/graph/panning.en': {
    frontmatter: fm128,
    toc: t128,
    demoIndex: dmi128,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.en.md?type=text'),
  },
  'docs/api/graph/panning.zh': {
    frontmatter: fm129,
    toc: t129,
    demoIndex: dmi129,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/panning.zh.md?type=text'),
  },
  'docs/api/registry/attr.en': {
    frontmatter: fm130,
    toc: t130,
    demoIndex: dmi130,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.en.md?type=text'),
  },
  'docs/api/registry/attr.zh': {
    frontmatter: fm131,
    toc: t131,
    demoIndex: dmi131,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/attr.zh.md?type=text'),
  },
  'docs/temp/ui/scrollbox.en': {
    frontmatter: fm132,
    toc: t132,
    demoIndex: dmi132,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/scrollbox.en.md?type=text'),
  },
  'docs/temp/ui/scrollbox.zh': {
    frontmatter: fm133,
    toc: t133,
    demoIndex: dmi133,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/scrollbox.zh.md?type=text'),
  },
  'docs/api/model/labels.en': {
    frontmatter: fm134,
    toc: t134,
    demoIndex: dmi134,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.en.md?type=text'),
  },
  'docs/api/model/labels.zh': {
    frontmatter: fm135,
    toc: t135,
    demoIndex: dmi135,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/labels.zh.md?type=text'),
  },
  'docs/api/model/marker.en': {
    frontmatter: fm136,
    toc: t136,
    demoIndex: dmi136,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.en.md?type=text'),
  },
  'docs/api/model/marker.zh': {
    frontmatter: fm137,
    toc: t137,
    demoIndex: dmi137,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/marker.zh.md?type=text'),
  },
  'docs/temp/ui/dropdown.en': {
    frontmatter: fm138,
    toc: t138,
    demoIndex: dmi138,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.en.md?type=text'),
  },
  'docs/temp/ui/dropdown.zh': {
    frontmatter: fm139,
    toc: t139,
    demoIndex: dmi139,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/dropdown.zh.md?type=text'),
  },
  'docs/temp/ui/splitbox.en': {
    frontmatter: fm140,
    toc: t140,
    demoIndex: dmi140,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.en.md?type=text'),
  },
  'docs/temp/ui/splitbox.zh': {
    frontmatter: fm141,
    toc: t141,
    demoIndex: dmi141,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/splitbox.zh.md?type=text'),
  },
  'docs/tutorial/devtool.en': {
    frontmatter: fm142,
    toc: t142,
    demoIndex: dmi142,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/devtool.en.md?type=text'),
  },
  'docs/tutorial/devtool.zh': {
    frontmatter: fm143,
    toc: t143,
    demoIndex: dmi143,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/devtool.zh.md?type=text'),
  },
  'docs/api/graph/graph.en': {
    frontmatter: fm144,
    toc: t144,
    demoIndex: dmi144,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.en.md?type=text'),
  },
  'docs/api/graph/graph.zh': {
    frontmatter: fm145,
    toc: t145,
    demoIndex: dmi145,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.zh.md?type=text'),
  },
  'docs/api/model/attrs.en': {
    frontmatter: fm146,
    toc: t146,
    demoIndex: dmi146,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.en.md?type=text'),
  },
  'docs/api/model/attrs.zh': {
    frontmatter: fm147,
    toc: t147,
    demoIndex: dmi147,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/attrs.zh.md?type=text'),
  },
  'docs/temp/components.en': {
    frontmatter: fm148,
    toc: t148,
    demoIndex: dmi148,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/components.en.md?type=text'),
  },
  'docs/temp/components.zh': {
    frontmatter: fm149,
    toc: t149,
    demoIndex: dmi149,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/components.zh.md?type=text'),
  },
  'docs/temp/ui/menubar.en': {
    frontmatter: fm150,
    toc: t150,
    demoIndex: dmi150,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menubar.en.md?type=text'),
  },
  'docs/temp/ui/menubar.zh': {
    frontmatter: fm151,
    toc: t151,
    demoIndex: dmi151,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menubar.zh.md?type=text'),
  },
  'docs/temp/ui/toolbar.en': {
    frontmatter: fm152,
    toc: t152,
    demoIndex: dmi152,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/toolbar.en.md?type=text'),
  },
  'docs/temp/ui/toolbar.zh': {
    frontmatter: fm153,
    toc: t153,
    demoIndex: dmi153,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/toolbar.zh.md?type=text'),
  },
  'docs/tutorial/update.en': {
    frontmatter: fm154,
    toc: t154,
    demoIndex: dmi154,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/update.en.md?type=text'),
  },
  'docs/tutorial/update.zh': {
    frontmatter: fm155,
    toc: t155,
    demoIndex: dmi155,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/update.zh.md?type=text'),
  },
  'docs/api/graph/grid.en': {
    frontmatter: fm156,
    toc: t156,
    demoIndex: dmi156,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.en.md?type=text'),
  },
  'docs/api/graph/grid.zh': {
    frontmatter: fm157,
    toc: t157,
    demoIndex: dmi157,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.zh.md?type=text'),
  },
  'docs/api/model/cell.en': {
    frontmatter: fm158,
    toc: t158,
    demoIndex: dmi158,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/cell.en.md?type=text'),
  },
  'docs/api/model/cell.zh': {
    frontmatter: fm159,
    toc: t159,
    demoIndex: dmi159,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/cell.zh.md?type=text'),
  },
  'docs/api/model/edge.en': {
    frontmatter: fm160,
    toc: t160,
    demoIndex: dmi160,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/edge.en.md?type=text'),
  },
  'docs/api/model/edge.zh': {
    frontmatter: fm161,
    toc: t161,
    demoIndex: dmi161,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/edge.zh.md?type=text'),
  },
  'docs/api/model/node.en': {
    frontmatter: fm162,
    toc: t162,
    demoIndex: dmi162,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/node.en.md?type=text'),
  },
  'docs/api/model/node.zh': {
    frontmatter: fm163,
    toc: t163,
    demoIndex: dmi163,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/model/node.zh.md?type=text'),
  },
  'docs/temp/animation.en': {
    frontmatter: fm164,
    toc: t164,
    demoIndex: dmi164,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/animation.en.md?type=text'),
  },
  'docs/temp/animation.zh': {
    frontmatter: fm165,
    toc: t165,
    demoIndex: dmi165,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/animation.zh.md?type=text'),
  },
  'docs/tutorial/about.en': {
    frontmatter: fm166,
    toc: t166,
    demoIndex: dmi166,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.en.md?type=text'),
  },
  'docs/tutorial/about.zh': {
    frontmatter: fm167,
    toc: t167,
    demoIndex: dmi167,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/about.zh.md?type=text'),
  },
  'docs/api/mvc/model.en': {
    frontmatter: fm168,
    toc: t168,
    demoIndex: dmi168,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/model.en.md?type=text'),
  },
  'docs/api/mvc/model.zh': {
    frontmatter: fm169,
    toc: t169,
    demoIndex: dmi169,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/model.zh.md?type=text'),
  },
  'docs/api/mvc/view.en': {
    frontmatter: fm170,
    toc: t170,
    demoIndex: dmi170,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/view.en.md?type=text'),
  },
  'docs/api/mvc/view.zh': {
    frontmatter: fm171,
    toc: t171,
    demoIndex: dmi171,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/mvc/view.zh.md?type=text'),
  },
  'docs/temp/ui/menu.en': {
    frontmatter: fm172,
    toc: t172,
    demoIndex: dmi172,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menu.en.md?type=text'),
  },
  'docs/temp/ui/menu.zh': {
    frontmatter: fm173,
    toc: t173,
    demoIndex: dmi173,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/ui/menu.zh.md?type=text'),
  },
  'docs/temp/layout.en': {
    frontmatter: fm174,
    toc: t174,
    demoIndex: dmi174,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/layout.en.md?type=text'),
  },
  'docs/temp/layout.zh': {
    frontmatter: fm175,
    toc: t175,
    demoIndex: dmi175,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/temp/layout.zh.md?type=text'),
  },
  'docs/xflow/store.en': {
    frontmatter: fm176,
    toc: t176,
    demoIndex: dmi176,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.en.md?type=text'),
  },
  'docs/xflow/store.zh': {
    frontmatter: fm177,
    toc: t177,
    demoIndex: dmi177,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.zh.md?type=text'),
  },
  'dumi-theme-antv-homepage': {
    frontmatter: fm178,
    toc: t178,
  },
  'dumi-theme-antv-homepage-en': {
    frontmatter: fm179,
    toc: t179,
  },
  'dumi-theme-antv-homepage-zh': {
    frontmatter: fm180,
    toc: t180,
  },
  'dumi-theme-antv-example-list-zh': {
    frontmatter: fm181,
    toc: t181,
  },
  'dumi-theme-antv-example-list-en': {
    frontmatter: fm182,
    toc: t182,
  },
}

export { tabs as tabsMeta } from './tabs';
